import React, { Fragment, useEffect } from "react";
import HambergerMenu from "../hamberger-menu/hamberger-menu";
import "./mainheader.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const MainHeader = () => {
  let badge = useSelector((state) => state.badge.counter);
  return (
    <Fragment>
      <div className="container-fluid main_nav">
        <div className="main_nav_body container">
          <div className="row row_body">
            <Link
              className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 header_basket_sec"
              to="/cart"
            >
              <div className=" cart_body">
                <div className="badge_body">{badge}</div>
                <div className="basket_icon_body">
                  <i className="uil uil-shopping-cart-alt"></i>
                </div>
                <div className="basket_text">سبد خرید</div>
              </div>
            </Link>
            <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 menu_body ">
              <ul className="ul_body">
                <Link style={{ textDecoration: "none" }} to="/about">
                  <li className="menu_item">درباره ما</li>
                </Link>

                <Link style={{ textDecoration: "none" }} to="/contact">
                  <li className="menu_item">تماس با ما</li>
                </Link>
                <Link style={{ textDecoration: "none" }} to="/catalog">
                  <li className="menu_item">فروشگاه</li>
                </Link>
                <Link style={{ textDecoration: "none" }} to="/">
                  <li className="menu_item">صفحه اصلی</li>
                </Link>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 logo_body ">
              <img src="https://s19.picofile.com/file/8440046734/lgo_arooski.jpg" />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid hamberger_menu_body">
        <HambergerMenu />
      </div>
    </Fragment>
  );
};
// test9

export default MainHeader;
